import type { IModelConnection } from "@itwin/core-frontend";
import { QueryBinder, QueryRowFormat } from "@itwin/core-common";
import { Remarks } from "../../../domain/common/Remarks";
import { DOTPayItemIndex } from "./dotPayItemQuery";

const DOTPAYITEM_SCHEMA =
  "DgnCustomItemTypes_DOT_DigitalAssetMetadata";

/**
 * Build the ECSQL to read Remarks info
 * for a given DOT_PayItem{index} aspect.
 */
function buildRemarksByElementQuery(index: DOTPayItemIndex): string {
  if (index < 1 || index > 5) {
    throw new Error(`Invalid DOT_PayItem index: ${index}`);
  }

  return `
    SELECT
      p.Remarks.Remarks AS Remarks
    FROM ${DOTPAYITEM_SCHEMA}.DOT_PayItem${index}ElementAspect p
    WHERE p.Element.Id = ?
  `;
}

export async function queryRemarksForElement(
  iModel: IModelConnection,
  elementId: string,
  index: DOTPayItemIndex,
): Promise<Remarks | undefined> {
  const bindings = QueryBinder.from([elementId]);

  const reader = iModel.createQueryReader(
    buildRemarksByElementQuery(index),
    bindings,
    { rowFormat: QueryRowFormat.UseECSqlPropertyNames }
  );

  for await (const row of reader) {
    const plain = row.toRow() as any;  // { Remarks }
    return Remarks.fromObject(plain);
  }

  // No Remarks info for that element/index
  return undefined;
}

